import React from 'react';
import Route from '../Route';
import { resolve } from '../../services/resolver';
import { ConversationErrors } from '../../services/gecko-error/errorConstants';
import GeckoRequest from '../../services/gecko-request';
import Conversations from './Conversations.jsx';
import ConversationErrorContainer from './components/ConversationErrorContainer';
import { CONSTS } from 'constants/index.js';

const renderError = (title, description) => {
  return (
    <div className="Conversations">
      <div className="conversation-wrapper">
        <div className="row no-gutters">
          <div className="col-3 convo-main-col"></div>
          <div className="col-6">
            <ConversationErrorContainer
              icon="far fa-comment-slash"
              title={title}
              description={description}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const routes = new Route({
  path: '/conversations',
  children: [
    {
      name: 'Conversations',
      path: '/',
      action: async function () {
        return <Conversations />;
      },
    },
    {
      name: 'Conversation',
      path: '/:conversation_id',
      resolves: {
        conversation_messages: ({ params }) => {
          return GeckoRequest.get(
            `/message/conversation/${params.conversation_id}`
          ).then((res) => res.messages);
        },
        conversation_activities: ({ params }) => {
          return GeckoRequest.get(
            `/conversation/${params.conversation_id}/activity?page=1&perPage=500&order_by_createdAt=ASC`
          ).then((res) => res.data);
        },
      },
      action: async function (context) {
        try {
          const { conversation_messages, conversation_activities } =
            await resolve(this.resolves, context);
          const messages = conversation_messages.data.map((message) => {
            return {
              ...message,
              recipient_channel: message.RecipientChannel,
              sender_channel: message.SenderChannel,
              sender: message.Sender,
            };
          });
          return (
            <Conversations
              conversation_id={context.params.conversation_id}
              messages={messages.reverse()}
              activities={conversation_activities.data}
              messagesPagination={conversation_messages.pagination}
              currentFilter={
                context.router.queryParams.filter ||
                CONSTS.FILTER_MY_CONVERSATIONS
              }
              conversationId={Number(context.params.conversation_id)}
            />
          );
        } catch (error) {
          const { name } = error;
          const errorMap = {
            [ConversationErrors.WEB_SAFE_AUTHORISATION_ERROR]: renderError(
              'Permission Denied',
              "It looks like you don't have the permission to view this conversation. If you need to see what is going on, ask an admin to assign you to the conversation."
            ),
            [ConversationErrors.WEB_SAFE_NOT_FOUND_ERROR]: renderError(
              'Not Found',
              "It looks like this conversation doesn't exist."
            ),
          };
          const errorDisplay = errorMap[name];
          if (errorDisplay) {
            return errorDisplay;
          }
          throw error;
        }
      },
    },
  ],
});

export default routes;
